import { useContext, useEffect, useState } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Dialog,
  Button,
  TextField,
  Typography,
  DialogContent,
  FormHelperText,
} from "@mui/material";
//Import from project
import "../../../Style/dialogstyle.scss";
import moment from "moment";
import { useMutation } from "@apollo/client";
import { AuthContext } from "../../../Context/AuthContext";
import {
  SelectSubjectByClassId,
  SelectStudentByClass,
} from "../../Include/DynamicSelect/DynamicSelect";
import { DialogTitleComp } from "../../../Utils/Component";
import { SelectDatePicker } from "../../Include/SelectDatePicker/SelectDatePicker";
import { CREATE_STUDENT_HOMEWORK } from "../../../Schema/HomeWork";

export default function CreateHomework({
  open,
  classId,
  editData,
  setRefetch,
  dialogTitle,
  handleClose,
}) {
  // Change Language
  const { t, setAlert, language } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createStudentHomework] = useMutation(CREATE_STUDENT_HOMEWORK, {
    onCompleted: ({ createStudentHomework }) => {
      setLoading(false);

      if (createStudentHomework?.isSuccess === true) {
        setAlert(true, "success", createStudentHomework?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createStudentHomework?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    checkDate: Yup.string().required(t("required")),
    exercise: Yup.string().required(t("required")),
    studentId: Yup.object().shape({
      id: Yup.string().required(t("required")),
      title: Yup.string(),
    }),
    subjectId: Yup.object().shape({
      id: Yup.string().required(t("required")),
      title: Yup.string(),
    }),
  });

  const formik = useFormik({
    initialValues: {
      exercise: "",
      studentId: { id: "", title: "" },
      subjectId: { id: "", title: "" },
      checkDate: moment(),
    },
    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setLoading(true);

      createStudentHomework({
        variables: {
          input: {
            classId: classId,
            exercise: values.exercise,
            checkDate: moment(values?.checkDate).format("YYYY-MM-DD"),
            studentId: values?.studentId?.id || null,
            subjectId: values?.subjectId?.id || null,
          },
        },
      });
    },
  });

  const {
    values,
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    getFieldProps,
    resetForm,
  } = formik;

  useEffect(() => {
    if (open) resetForm();
  }, [open]);
  console.log("errors :", errors);
  return (
    <Dialog open={open} className="dialog-container" maxWidth="sm" fullWidth>
      <DialogTitleComp
        title={
          dialogTitle === "Create"
            ? t("modal_title_create_homework")
            : t("modal_title_update_homework")
        }
        classTitle={"dialog-title"}
        classIcon={"close-icon"}
        handleClose={handleClose}
      />

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12} sm={12} md={6.1} lg={6.1} xl={6.1}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_date")}
                </Typography>
                <SelectDatePicker
                  value={values?.checkDate}
                  onChange={(val) => setFieldValue("checkDate", val || null)}
                />
                {!!errors.checkDate && touched.checkDate && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.checkDate}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_student")}
                </Typography>
                <SelectStudentByClass
                  classId={classId}
                  value={values?.studentId}
                  onChange={(val) => setFieldValue("studentId", val)}
                />
                {!!errors.studentId?.id && touched.studentId?.id && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.studentId?.id}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_subject")}
                </Typography>
                <SelectSubjectByClassId
                  value={values?.subjectId}
                  classId={classId}
                  onChange={(val) => setFieldValue("subjectId", val)}
                />
                {!!errors.subjectId?.id && touched.subjectId?.id && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.subjectId?.id}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_exercise")}
                </Typography>
                <TextField
                  rows={2}
                  fullWidth
                  multiline
                  size="small"
                  className="text-field"
                  placeholder={t("thead_exercise")}
                  {...getFieldProps("exercise")}
                  error={Boolean(touched.exercise && errors.exercise)}
                  helperText={touched.exercise && errors.exercise}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {loading ? (
                  <Button className={t("class-btn-create")} fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    fullWidth
                    onClick={handleSubmit}
                    className={t("class-btn-create")}
                  >
                    {dialogTitle === "Update" ? t("update") : t("create")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
